export default "__VITE_ASSET__7a18854e__"